// extracted by mini-css-extract-plugin
export default {"wrapper":"LockedButton_wrapper__PfKwj","locked":"LockedButton_locked__oaTn7","lockedIcon":"LockedButton_lockedIcon__3Vddl","lockedText":"LockedButton_lockedText__8m8h2"};